import axios from 'axios';
import envConfig from 'commons-vehicle/config/index.js';
import { ConfigsService, HTTPService, TokenService } from '@sm360/widget-commons-core-services';
import { AccountService } from '@sm360/widget-commons-general';

class TradeInsService {
    constructor() {
        this.basePath = `${envConfig.endpoint.tradein}`;
    }

    loadTradeInVehicle(config) {
        if (!AccountService.isAuthenticated()) {
            return Promise.reject(HTTPService.formatRejectResponse('user not authenticated'));
        }

        const organizationId = config?.orgId || ConfigsService.getOrganizationId();
        const organizationUnitId = config?.orgUnitId || ConfigsService.getOrganizationUnitId();
        const organizationLocation = config?.location || ConfigsService.getOrganizationUnitLocation();

        return AccountService.getLoggedAccount()
            .then((account) => {
                const { id: accountId, contactId } = account;
                return TokenService.fetch().then((accessToken) =>
                    axios.get(
                        `${this.basePath}/tradeIn?${[
                            `contactId=${contactId}`,
                            `accountId=${accountId}`,
                            `orgId=${organizationId}`,
                            `orgUnitId=${organizationUnitId}`,
                            `orgLocation=${organizationLocation}`,
                        ].join('&')}`,
                        {
                            headers: {
                                Authorization: `Bearer ${accessToken}`,
                            },
                        }
                    )
                );
            })
            .then((result) => {
                return result.data;
            })
            .catch(() => Promise.resolve(null));
    }

    updateTradeIn(tradeIn, config) {
        if (!AccountService.isAuthenticated()) {
            return Promise.reject(HTTPService.formatRejectResponse('user not authenticated'));
        }

        const orgId = config?.orgId || ConfigsService.getOrganizationId();
        const orgUnitId = config?.orgUnitId || ConfigsService.getOrganizationUnitId();
        const orgLocation = config?.location || ConfigsService.getOrganizationUnitLocation();

        const tradeInToUpdate = {
            ...tradeIn,
            orgId,
            orgUnitId,
            orgLocation,
        };

        return TokenService.fetch()
            .then((accessToken) =>
                axios.put(`${this.basePath}/tradeIn?`, tradeInToUpdate, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                })
            )
            .then((result) => {
                return result.data;
            });
    }

    deleteTradeIn(tradeIn) {
        if (!AccountService.isAuthenticated()) {
            return Promise.reject(HTTPService.formatRejectResponse('user not authenticated'));
        }

        const { tradeId } = tradeIn;
        return TokenService.fetch()
            .then((accessToken) =>
                axios.delete(`${this.basePath}/tradeIn/${tradeId}?`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                })
            )
            .then((result) => {
                return result;
            });
    }
}

export default new TradeInsService();
